// import React from "react";
// import { Modal, Button, Divider } from "antd";

// const PackageSummaryModal = ({
//   open,
//   onClose,
//   onProceed,
//   furniture,
//   houseware,
//   deliveryPrice = 0,
// }) => {
//   // Split data into two categories
// //   const furniture = data.filter(item => item.type === "furniture");
// //   const houseware = data.filter(item => item.type === "houseware");

//   // Calculate totals
//   const furnitureTotal = furniture.reduce((acc, item) => acc + (item.price || 0), 0);
//   const housewareTotal = houseware.reduce((acc, item) => acc + (item.price || 0), 0);
//   const total = furnitureTotal + housewareTotal + deliveryPrice;

//   return (
//     <Modal
//       title="Your Package Summary"
//       open={open}
//       onCancel={onClose}
//       footer={null}
//       width={700}
//       centered
//     >
//       {/* Furniture Section */}
//       {furniture.length > 0 && (
//         <>
//           <h3 style={{ color: "#004aad", marginBottom: 8 }}>Furniture Packages</h3>
//           {furniture.map((item, index) => (
//             <div
//               key={index}
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 marginBottom: 4,
//               }}
//             >
//               <span>{item.packageName}</span>
//               <span>${item.price}</span>
//             </div>
//           ))}
//           <Divider />
//         </>
//       )}

//       {/* Houseware Section */}
//       {houseware.length > 0 && (
//         <>
//           <h3 style={{ color: "#004aad", marginBottom: 8 }}>Houseware Packages</h3>
//           {houseware.map((item, index) => (
//             <div
//               key={index}
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 marginBottom: 4,
//               }}
//             >
//               <span>{item.packageName}</span>
//               <span>${item.price}</span>
//             </div>
//           ))}
//           <Divider />
//         </>
//       )}

//       {/* Delivery Fee */}
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           fontWeight: 500,
//           marginBottom: 8,
//         }}
//       >
//         <span>Delivery Fee</span>
//         <span>${deliveryPrice}</span>
//       </div>

//       {/* Total */}
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           fontSize: 16,
//           fontWeight: "bold",
//           color: "#004aad",
//           marginBottom: 20,
//         }}
//       >
//         <span>Total</span>
//         <span>${total}</span>
//       </div>

//       {/* Proceed Button */}
//       <div style={{ textAlign: "center" }}>
//         <Button type="primary" size="large" onClick={onProceed}>
//           Proceed
//         </Button>
//       </div>
//     </Modal>
//   );
// };

// export default PackageSummaryModal;

import React, { useMemo } from "react";
import { Modal, Button, Divider, Empty, Collapse } from "antd";

export const PricingSummaryModal = ({
  open,
  onClose,
  onProceed,
  furniture = [],
  houseware = [],
  deliveryPrice = 0,
  packageName = "",
  addOnItems,
}) => {
  const furnitureTotal = useMemo(() => {
    return furniture.reduce((sum, item) => {
      const price = parseFloat(String(item.price)) || 0;
      const quantity = item.quantity || 1;
      return sum + price * quantity;
    }, 0);
  }, [furniture]);

  const housewareTotal = useMemo(() => {
    return houseware.reduce((sum, item) => {
      const price = parseFloat(String(item.price)) || 0;
      const quantity = item.quantity || 1;
      return sum + price * quantity;
    }, 0);
  }, [houseware]);
  const NewfurnitureTotal = useMemo(() => {
    const furniture =
      addOnItems && addOnItems?.filter((item) => item.type === "furniture");
    return furniture?.reduce((sum, item) => {
      const price = parseFloat(String(item.price)) || 0;
      const quantity = item.quantity || 1;
      return sum + price * quantity;
    }, 0);
  }, [addOnItems]);

  const NewhousewareTotal = useMemo(() => {
    const houseware =
      addOnItems && addOnItems?.filter((item) => item.type === "houseware");
    return houseware?.reduce((sum, item) => {
      const price = parseFloat(String(item.price)) || 0;
      const quantity = item.quantity || 1;
      return sum + price * quantity;
    }, 0);
  }, [addOnItems]);

  const grandTotal = furnitureTotal + housewareTotal + (addOnItems?.length > 0 && NewfurnitureTotal) +  (addOnItems?.length > 0 && NewhousewareTotal) + deliveryPrice;
  const hasItems = furniture.length > 0 || houseware.length > 0;

  const furnitureDetails = furniture
    .map((item) => `${item.quantity} X ${item.name}`)
    .join(", ");
  const housewareDetails = houseware
    .map((item) => `${item.quantity} X ${item.name}`)
    .join(", ");
  const NewFurnitureDetails = addOnItems
    ?.filter((item) => item.type === "furniture")
    .map((item) => `${item.quantity} X ${item.name}`)
    .join(", ");
  const NewHousewareDetails = addOnItems
    ?.filter((item) => item.type === "houseware")
    .map((item) => `${item.quantity} X ${item.name}`)
    .join(", ");

  const collapseItems = [
    ...(furniture.length > 0
      ? [
          {
            key: "furniture",
            label: (
              <div className="d-flex justify-content-between w-100 pe-3">
                <span className="">Furniture items</span>
                <span className="fw-semibold">
                  ${furnitureTotal.toFixed(2)}
                </span>
              </div>
            ),
            children: (
              <div className="small text-muted">({furnitureDetails})</div>
            ),
          },
        ]
      : []),
    ...(houseware.length > 0
      ? [
          {
            key: "houseware",
            label: (
              <div className="d-flex justify-content-between w-100 pe-3">
                <span className="">Houseware items</span>
                <span className="fw-semibold">
                  ${housewareTotal.toFixed(2)}
                </span>
              </div>
            ),
            children: (
              <div className="small text-muted">({housewareDetails})</div>
            ),
          },
        ]
      : []),
  ];
  const NewcollapseItems = [
    ...(NewFurnitureDetails?.length > 0
      ? [
          {
            key: "furniture",
            label: (
              <div className="d-flex justify-content-between w-100 pe-3">
                <span className="">Furniture items</span>
                {/* <span className="fw-semibold">${NewFurnitureDetails.toFixed(2)}</span> */}
              </div>
            ),
            children: (
              <div className="small text-muted">({NewFurnitureDetails})</div>
            ),
          },
        ]
      : []),
    ...(NewHousewareDetails?.length > 0
      ? [
          {
            key: "houseware",
            label: (
              <div className="d-flex justify-content-between w-100 pe-3">
                <span className="">Houseware items</span>
                {/* <span className="fw-semibold">${NewHousewareDetails.toFixed(2)}</span> */}
              </div>
            ),
            children: (
              <div className="small text-muted">({NewHousewareDetails})</div>
            ),
          },
        ]
      : []),
  ];
  return (
    <Modal
      title={`${packageName} Package Summary`}
      open={open}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button key="proceed" type="primary" onClick={onProceed}>
          Proceed
        </Button>,
      ]}
      width={500}
    >
      <div className="mb-4">
        {!hasItems && <Empty description="No items selected" />}
        {hasItems && (
          <>
            <Collapse items={collapseItems} bordered={false} />
            {NewcollapseItems.length > 0 && (
              <>
                <span className="fw-semibold">Additional Items</span>
                <Collapse items={NewcollapseItems} bordered={false} />
              </>
            )}
            {deliveryPrice > 0 && (
              <div className="bg-light p-3 rounded d-flex justify-content-between align-items-center mt-3">
                <span className="text-secondary fw-medium">Delivery price</span>
                <span className="fw-semibold fs-5">
                  ${deliveryPrice.toFixed(2)}
                </span>
              </div>
            )}

            <Divider className="my-4" />

            <div className=" rounded d-flex justify-content-between align-items-center">
              <span className="fw-bold text-dark fs-5">Total</span>
              <span className="fw-bold fs-4">${grandTotal.toFixed(2)}</span>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};
export default PricingSummaryModal;
